import { Navigate } from 'react-router';
import type { User } from 'oidc-client-ts';
import { isAdmin } from './authService.ts';

interface Props {
  user: User | null;
  role?: string;
  children: JSX.Element;
}

export function ProtectedRoute({ user, isAdmin, role, children }: Props) {
  const isAuthenticated = !!user && !user.expired;
  const hasRole = role === 'admin' ? !!isAdmin : true;

  if (!isAuthenticated) return <Navigate to='/unauthorised' replace />;
  if (!hasRole) return <Navigate to='/unauthorised' replace />;
  return children;
}
